module.exports = __webpack_public_path__ + "static/media/favicon.fdf2d2dc.ico";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/citylink/favicon.ico
// module id = 657
// module chunks = 0